import request from '@utils/request';
import { QueryClient, useQuery } from '@tanstack/react-query';
import { Page } from 'shared-types';

export function useGetSpaStaysPage(propertyId: number, language: string, enabled = true) {
  return useQuery({
    queryKey: getSpaStaysPageKey(propertyId, language),
    queryFn: () => getSpaStaysPage(propertyId, language),
    staleTime: Infinity,
    enabled,
  });
}

export async function getSpaStaysPage(propertyId: number, language: string) {
  const response = await request.get(`${propertyId}/pages/spa-stays/${language}`, {
    isPayloadCaseConverterDisabled: true,
  });
  if (response.status === 204) {
    return null;
  }
  return response.data as Page;
}

export const getSpaStaysPageKey = (propertyId: number, language: string) => [
  'spaStaysPage',
  propertyId,
  language,
];

export const getSpaStaysPagePrefetch = (
  queryClient: QueryClient,
  propertyId: number,
  language: string
) =>
  queryClient.prefetchQuery(getSpaStaysPageKey(propertyId, language), () =>
    getSpaStaysPage(propertyId, language)
  );
